var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"max-w-sm"},[_c('Input',{attrs:{"label":_vm.label,"type":"password"},on:{"change":_vm.input}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }